import { Injectable } from "@angular/core";
import { BehaviorSubject, of } from "rxjs";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Screen } from "../models/screens.model";
import { AuthService } from "./auth.service";
import { an } from "@fullcalendar/core/internal-common";

@Injectable({ providedIn: 'root' })
export class UserRightsService {
    API_USERS_URL = `${environment.apiUrl}`;

    httpOptions = {
        headers: new HttpHeaders({
            "Content-Type": "application/json",
        }),
    };
    dataChange: BehaviorSubject<Screen[]> = new BehaviorSubject<Screen[]>([]);
    // Temporarily stores data from dialogs
    dialogData: any;
    constructor(
        private httpClient: HttpClient,
        private authService: AuthService
    ) { }
    get data(): Screen[] {
        return this.dataChange.value;
    }
    getRights(module_id: any): Observable<any> {
        const auth = this.authService.getAuthFromLocalStorage();
        if (!auth || !auth.token) {
            return of(undefined);
        }
        return this.httpClient
            .get<any>(`${this.API_USERS_URL}/userrights/all/` + module_id, {
                headers: new HttpHeaders({
                    Authorization: "Bearer " + auth.token,

                    Accept: "application/json",
                }),
            })
            .pipe(catchError(this.errorHandler));
    }
    module_screen(module_id: any, user_id: any, group_id: any): Observable<any> {
        var data = {
            "module_id": module_id,
            "user_id": user_id,
            "group_id": group_id
        }
        const auth = this.authService.getAuthFromLocalStorage();
        if (!auth || !auth.token) {
            return of(undefined);
        }
        return this.httpClient.post(
            `${this.API_USERS_URL}/userrights/modulescreen/`, data,
            {
                headers: new HttpHeaders({
                    Authorization: "Bearer " + auth.token,

                    Accept: "application/json",
                }),
            }
        );
    }
    // add userRights api
    addUserRights(userRights: any): Observable<any> {
        const auth = this.authService.getAuthFromLocalStorage();
        if (!auth || !auth.token) {
            return of(undefined);
        }


        console.log(userRights)
        return this.httpClient.post<any>(
            `${this.API_USERS_URL}/userrights/`,
            userRights,
            {
                headers: new HttpHeaders({
                    Authorization: "Bearer " + auth.token,

                    Accept: "application/json",
                }),
            }
        );
    }
    importlist(search: any): Observable<any> {
        let params = new HttpParams();
        if (search.title != null && search.title != "") {
            params = params.append("title", search.title);
        }
        if (search.code != null && search.code != "") {
            params = params.append("code", search.code);
        }

        const auth = this.authService.getAuthFromLocalStorage();
        if (!auth || !auth.token) {
            return of(undefined);
        }
        return this.httpClient.get<any>(
            `${this.API_USERS_URL}/userrights/import?` + params,
            {
                headers: new HttpHeaders({
                    'Authorization': 'Bearer ' + auth.token,

                    Accept: "application/json",
                }),
            }
        );
    }
    /**
     * Generic permission check for use throughout the project
     * @param screen string - the screen_name to check
     * @param action string - the action_name to check
     * @returns boolean - true if user has permission or is super admin
     */


    errorHandler(error) {
        let errorMessage = "";
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}
